__turbopack_context__.v({
  "className": "lJ9sBq_className",
  "variable": "lJ9sBq_variable",
});
